import { AppealCurrentStatus } from "@/__generated__/graphql";

export const APPEAL_CURRENT_STATUS_VALUES: readonly AppealCurrentStatus[] =
  Object.values(AppealCurrentStatus);
